import { Navigate, useParams } from 'react-router-dom';
import KnowledgeForm from '../../../components/knowledges/KnowledgeForm/KnowledgeForm';
import Page from '../../../components/shared/Page/Page';
import { getKnowledge } from '../../../services/knowledgeService';
import { useEffect, useState } from 'react';
import { ResponseObject, WorkflowType } from '../../../interfaces/App';
import Loading from '../../../components/shared/Loading/Loading';

const EditKnowledge = () => {
  const { id } = useParams();
  const [knowledge, setKnowledge] = useState(null);

  const initializeKnowledge = async () => {
    if (!id) {
      return <Navigate to="/dashboard" />;
    }
    const knowledge: ResponseObject = await getKnowledge(id);
    setKnowledge(knowledge?.message);
  };

  useEffect(() => {
    initializeKnowledge();
  }, []);

  if (!knowledge) return <Loading />;

  return (
    <Page withBackground hideMainMenu>
      <KnowledgeForm knowledge={knowledge} workflow={WorkflowType.EDIT} />
    </Page>
  );
};

export default EditKnowledge;
